/* ============================================================================
   HDZB · OBALUS store runtime. Vanilla, no libraries. window.HDZB is the API.
   Config comes from snippets/hdzb-head.liquid (window.HDZB_CFG).
   Money: amounts are ALWAYS integer cents in the store's ACTIVE currency (Shopify Markets
   renders UZS for Uzbekistan etc.); the symbol comes from Shopify's own money format, so
   HDZB.money(5999) → "$59.99" for US visitors and "720 000 som" for UZ visitors. Never hardcode "$".
   ========================================================================== */
(function () {
  'use strict';
  if (window.HDZB && window.HDZB.__v) return;
  var CFG = window.HDZB_CFG || {};
  var R = CFG.routes || {};
  var root = R.root || '/';
  if (root.length > 1 && root.slice(-1) === '/') root = root.slice(0, -1);
  if (root === '/') root = '';
  var H = { __v: '1.1.0', cfg: CFG };
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return !!RM.matches; }
  H.reducedMotion = reduced;
  var listeners = {};

  /* ---------- tiny helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { el.addEventListener(ev, fn, opts || false); return function () { el.removeEventListener(ev, fn, opts || false); }; }
  function emit(name, detail) {
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) { /* old webview */ }
    (listeners[name] || []).forEach(function (fn) { try { fn(detail); } catch (e) { console.error(e); } });
  }
  H.on = function (name, fn) { (listeners[name] = listeners[name] || []).push(fn); return function () { listeners[name] = listeners[name].filter(function (x) { return x !== fn; }); }; };
  H.emit = emit; H.$ = $; H.$$ = $$;
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  H.esc = esc;

  /* ---------- money (port of Shopify's format rules; symbol follows the active currency) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    var neg = cents < 0; var abs = Math.abs(cents);
    var fmt = format || CFG.moneyFormat || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function num(dec, thou, decSep) {
      var s = (abs / 100).toFixed(dec);
      var parts = s.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec ? whole + decSep + parts[1] : whole;
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(0, '.', ','); break;
      case 'amount_with_space_separator': v = num(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = num(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = num(2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': v = num(2, ' ', '.'); break;
      default: v = num(2, ',', '.');
    }
    var out = m ? fmt.replace(m[0], v) : v;
    return (neg ? '-' : '') + out;
  }
  /* money(cents, {trim:true}) → "$60" instead of "$60.00" ; {withCurrency:true} → "$59.99 USD" */
  H.money = function (cents, o) {
    o = o || {};
    var s = formatMoney(cents, o.withCurrency ? CFG.moneyWithCurrencyFormat : CFG.moneyFormat);
    if (o.trim) s = s.replace(/([.,])00(?=\D|$)/, '');
    return s;
  };
  H.currency = CFG.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  H.rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
  /* a USD amount (cents) expressed in the active currency, for thresholds like "free shipping $100+" */
  H.usd = function (usdCents) { return Math.round(usdCents * H.rate); };

  /* ---------- cart ---------- */
  var cartState = null;
  function jsonFetch(url, opts) {
    opts = opts || {};
    var headers = { 'Accept': 'application/json' };
    if (opts.body) headers['Content-Type'] = 'application/json';
    return fetch(url, { method: opts.method || 'GET', credentials: 'same-origin', headers: headers, body: opts.body ? JSON.stringify(opts.body) : undefined })
      .then(function (r) {
        /* a 429/5xx can come back as an HTML page: never show a raw parse error to the shopper */
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!r.ok || j === null) {
            var msg = (j && (j.description || j.message)) || (r.status === 429 ? 'The store is busy for a moment. Wait a minute and try again.' : 'Could not update the cart. Please try again.');
            var e = new Error(msg); e.data = j; e.status = r.status; throw e;
          }
          return j;
        });
      });
  }
  function setCart(c, source) {
    if (!c || typeof c.item_count !== 'number') return c;
    cartState = c;
    updateCounts(c.item_count);
    emit('hdzb:cart', { cart: c, source: source || 'refresh' });
    return c;
  }
  function bump(el) {
    if (reduced()) return;
    el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    setTimeout(function () { el.classList.remove('is-bump'); }, 450);
  }
  H.bump = bump;
  function updateCounts(n) {
    $$('[data-hdzb-cart-count]').forEach(function (el) {
      var prev = Number(el.getAttribute('data-n') || el.textContent) || 0;
      el.textContent = String(n); el.setAttribute('data-n', String(n)); el.classList.toggle('is-on', n > 0);
      if (n > prev) bump(el);
    });
  }
  function upcartRefresh() {
    try { if (typeof window.upcartRefreshCart === 'function') { var p = window.upcartRefreshCart(); return (p && p.then) ? p.catch(function () {}) : Promise.resolve(); } } catch (e) { }
    return Promise.resolve();
  }
  var cart = {
    get state() { return cartState; },
    get: function () { return jsonFetch(root + '/cart.js').then(function (c) { return setCart(c, 'get'); }); },
    refresh: function () { return cart.get(); },
    /* add(variantId) · add({id, quantity, properties}) · add([{id, quantity}, …]) ; opts: {open:true, toast:'Added'} */
    add: function (items, opts) {
      opts = opts || {};
      var list = Array.isArray(items) ? items : [items];
      list = list.map(function (it) { return typeof it === 'object' ? it : { id: Number(it), quantity: 1 }; })
        .map(function (it) { return { id: Number(it.id), quantity: Number(it.quantity) || 1, properties: it.properties, selling_plan: it.selling_plan }; });
      return jsonFetch(root + '/cart/add.js', { method: 'POST', body: { items: list } })
        .then(function (res) {
          return cart.get().then(function (c) {
            emit('hdzb:cart:added', { items: list, response: res, cart: c });
            return upcartRefresh().then(function () {
              if (opts.open !== false) cart.open();
              if (opts.toast) H.toast(opts.toast, { kind: 'ok' });
              return res;
            });
          });
        })
        .catch(function (e) { emit('hdzb:cart:error', { error: e, items: list }); if (opts.toast !== false) H.toast(e.message || 'Could not add to cart. Please try again.', { kind: 'err' }); throw e; });
    },
    /* change(line|key, quantity) — line is 1-based index or the item key */
    change: function (lineOrKey, quantity) {
      var body = { quantity: Number(quantity) };
      if (typeof lineOrKey === 'string' && lineOrKey.indexOf(':') > -1) body.id = lineOrKey; else body.line = Number(lineOrKey);
      return jsonFetch(root + '/cart/change.js', { method: 'POST', body: body }).then(function (c) { setCart(c, 'change'); upcartRefresh(); return c; });
    },
    remove: function (lineOrKey) { return cart.change(lineOrKey, 0); },
    update: function (payload) { return jsonFetch(root + '/cart/update.js', { method: 'POST', body: payload }).then(function (c) { setCart(c, 'update'); upcartRefresh(); return c; }); },
    clear: function () { return jsonFetch(root + '/cart/clear.js', { method: 'POST', body: {} }).then(function (c) { setCart(c, 'clear'); upcartRefresh(); return c; }); },
    /* Discount code on the cart (verified 30.09.2026 on this store: POST /cart/update.js {discount:"CODE"} → cart.discount_codes[{code, applicable}]).
       Resolves {applied:boolean, code, cart}. Fallback for old webviews: HDZB.checkout({discount:CODE}). */
    setDiscount: function (code) {
      code = String(code || '').trim();
      return jsonFetch(root + '/cart/update.js', { method: 'POST', body: { discount: code } }).then(function (c) {
        setCart(c, 'discount'); upcartRefresh();
        var found = (c.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code.toUpperCase(); })[0];
        var applied = !!(found && found.applicable);
        emit('hdzb:discount', { code: code, applied: applied, cart: c });
        return { applied: applied, code: code, cart: c };
      });
    },
    clearDiscount: function () { return jsonFetch(root + '/cart/update.js', { method: 'POST', body: { discount: '' } }).then(function (c) { setCart(c, 'discount'); upcartRefresh(); emit('hdzb:discount', { code: '', applied: false, cart: c }); return c; }); },
    getDiscounts: function () { return (cartState && cartState.discount_codes) || []; },
    /* the UpCart drawer (app). Falls back to the cart page when the app is absent. */
    open: function () {
      if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return true; } catch (e) { } }
      window.location.href = root + '/cart';
      return false;
    },
    close: function () { if (typeof window.upcartCloseCart === 'function') { try { window.upcartCloseCart(); } catch (e) { } } },
    count: function () { return cartState ? cartState.item_count : (Number(CFG.cartCount) || 0); }
  };
  H.cart = cart;
  H.checkout = function (o) { o = o || {}; var u = root + '/checkout'; if (o.discount) u += '?discount=' + encodeURIComponent(o.discount); window.location.href = u; };

  /* legacy alias — the bundle engine (assets/hdzs.js, window.HDZS, Theme settings → Bundle deals) owns the tier codes now */
  H.setup = {
    get code() { var s = window.HDZS && window.HDZS.state(); return (s && s.code) || ''; },
    get amountCents() { var s = window.HDZS && window.HDZS.state(); return (s && s.amount) || 0; },
    apply: function () { return window.HDZS ? window.HDZS.refresh() : Promise.resolve(null); },
    clear: function () { return cart.clearDiscount(); }
  };

  /* ---------- toast ---------- */
  var toastHost;
  H.toast = function (msg, o) {
    o = o || {};
    if (!toastHost) { toastHost = document.createElement('div'); toastHost.className = 'hdzb hdzb-toast-host'; toastHost.setAttribute('aria-live', 'polite'); document.body.appendChild(toastHost); }
    var t = document.createElement('div');
    t.className = 'hdzb-toast' + (o.kind === 'ok' ? ' hdzb-toast--ok' : o.kind === 'err' ? ' hdzb-toast--err' : '');
    var icon = o.kind === 'ok' ? '<svg class="hdzb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' : '';
    t.innerHTML = icon + '<span></span>';
    t.querySelector('span').textContent = msg;
    toastHost.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 250); }, o.ms || 2600);
    return t;
  };

  /* ---------- scroll lock + focus trap (drawers, dialogs) ---------- */
  var lockY = 0, locked = false;
  H.lockScroll = function (state) {
    var de = document.documentElement, b = document.body;
    if (state && !locked) { lockY = window.scrollY || 0; locked = true; b.style.top = -lockY + 'px'; b.style.position = 'fixed'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%'; de.classList.add('hdzb-scroll-lock'); }
    else if (!state && locked) { locked = false; b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = ''; de.classList.remove('hdzb-scroll-lock'); window.scrollTo(0, lockY); }
  };
  var FOCUS = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  H.trapFocus = function (container, opts) {
    opts = opts || {};
    var prev = document.activeElement;
    var offKey = on(container, 'keydown', function (e) {
      if (e.key === 'Escape' && opts.onEscape) { e.preventDefault(); opts.onEscape(); return; }
      if (e.key !== 'Tab') return;
      var f = $$(FOCUS, container).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    var target = opts.initial ? $(opts.initial, container) : $$(FOCUS, container).filter(function (el) { return el.offsetParent !== null; })[0];
    if (target) setTimeout(function () { target.focus(); }, 30);
    return function release() { offKey(); if (prev && prev.focus && opts.restore !== false) prev.focus(); };
  };

  /* ---------- header: sticky host, compact on scroll, drawer, search, cart button ---------- */
  function initHeader() {
    var hdr = $('[data-hdzb-header]');
    if (!hdr) return;
    var host = hdr.closest('.shopify-section') || hdr.parentElement;
    if (host && host !== document.body) host.classList.add('hdzb-sticky-host');
    var headerEl = $('.hdzb-header', hdr) || hdr;
    /* v1.2 header-height contract: --hdzb-header-h = the header's rendered height (border included), always.
       Sticky bars use top: var(--hdzb-header-h) and sit flush. Measured with ResizeObserver (fonts, wraps, resizes);
       the header's own min-height uses --hdzb-header-row, so measuring never feeds back into its size. */
    var lastH = -1;
    function setH(h) { h = Math.round(h * 100) / 100; if (h > 0 && h !== lastH) { lastH = h; document.documentElement.style.setProperty('--hdzb-header-h', h + 'px'); } }
    function measure() { setH(headerEl.getBoundingClientRect().height); }
    if ('ResizeObserver' in window) {
      try { new ResizeObserver(function (es) { var e = es[es.length - 1], bs = e && e.borderBoxSize && (e.borderBoxSize[0] || e.borderBoxSize); setH(bs && bs.blockSize ? bs.blockSize : headerEl.getBoundingClientRect().height); }).observe(headerEl); } catch (e) { }
    }
    on(window, 'resize', debounce(measure, 150)); measure(); setTimeout(measure, 400);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure).catch(function () { });
    /* compact = visual only (logo scale; the box keeps its height → no layout shift → no scroll-anchoring loop).
       Hysteresis: on above 96px, off below 24px, so resting near a threshold never flickers. */
    var ticking = false, compact = false, C_ON = 96, C_OFF = 24;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || 0, want = compact ? y > C_OFF : y > C_ON;
        if (want !== compact) { compact = want; headerEl.classList.toggle('is-compact', compact); }
        ticking = false;
      });
    }
    on(window, 'scroll', onScroll, { passive: true }); onScroll();

    /* cart button → UpCart drawer (UpCart also intercepts a[href*='/cart'] itself; both are idempotent) */
    $$('[data-hdzb-cart-open]').forEach(function (b) {
      on(b, 'click', function (e) { if (typeof window.upcartOpenCart === 'function') { e.preventDefault(); cart.open(); } });
    });
    /* count: initial + keep in sync with UpCart (it writes into span[data-cart-count]) */
    var countEl = $('[data-hdzb-cart-count]', hdr);
    if (countEl) {
      countEl.classList.toggle('is-on', Number(countEl.textContent) > 0);
      countEl.setAttribute('data-n', String(Number(countEl.textContent) || 0));
      /* UpCart writes the number itself → keep the badge visible and bump when it grows */
      if ('MutationObserver' in window) new MutationObserver(function () {
        var n = Number(countEl.textContent) || 0, prev = Number(countEl.getAttribute('data-n')) || 0;
        countEl.classList.toggle('is-on', n > 0);
        if (n !== prev) { countEl.setAttribute('data-n', String(n)); if (n > prev) bump(countEl); }
      }).observe(countEl, { childList: true, characterData: true, subtree: true });
    }

    /* mobile drawer */
    var drawer = $('[data-hdzb-drawer]'), openBtn = $('[data-hdzb-menu-open]', hdr), release = null;
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      H.lockScroll(false);
      if (release) { release(); release = null; }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 220);
    }
    function openDrawer() {
      if (!drawer) return;
      closeSearch();
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      H.lockScroll(true);
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      release = H.trapFocus($('.hdzb-drawer__p', drawer) || drawer, { onEscape: closeDrawer, initial: '[data-hdzb-drawer-close]' });
    }
    if (openBtn && drawer) {
      on(openBtn, 'click', function (e) { e.preventDefault(); drawer.hidden ? openDrawer() : closeDrawer(); });
      $$('[data-hdzb-drawer-close]', drawer).forEach(function (b) { on(b, 'click', closeDrawer); });
      /* expandable category rows (plus button → sub-links) */
      $$('[data-hdzb-dsub]', drawer).forEach(function (b) {
        on(b, 'click', function () {
          var p = document.getElementById(b.getAttribute('aria-controls')); if (!p) return;
          var open = b.getAttribute('aria-expanded') !== 'true';
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          p.classList.toggle('is-open', open);
        });
      });
    }
    H.menu = { open: openDrawer, close: closeDrawer };

    /* desktop dropdowns: hover (with intent delay) on mouse, chevron button for keyboard/touch, Esc closes */
    var dds = $$('[data-hdzb-dd]', hdr), openDD = null, tIn = null, tOut = null;
    var canHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
    function ddBtn(it) { return $('.hdzb-nav__tog', it); }
    function closeDD(it) {
      it = it || openDD; if (!it) return;
      it.classList.remove('is-open'); var b = ddBtn(it); if (b) b.setAttribute('aria-expanded', 'false');
      if (openDD === it) openDD = null;
    }
    function openDDi(it) {
      clearTimeout(tOut);
      if (openDD && openDD !== it) closeDD(openDD);
      closeSearch();
      it.classList.add('is-open'); var b = ddBtn(it); if (b) b.setAttribute('aria-expanded', 'true');
      openDD = it;
    }
    dds.forEach(function (it) {
      var b = ddBtn(it);
      on(it, 'mouseenter', function () { if (!canHover.matches) return; clearTimeout(tOut); clearTimeout(tIn); tIn = setTimeout(function () { openDDi(it); }, openDD ? 0 : 110); });
      on(it, 'mouseleave', function () { if (!canHover.matches) return; clearTimeout(tIn); tOut = setTimeout(function () { closeDD(it); }, 200); });
      if (b) on(b, 'click', function (e) { e.preventDefault(); it.classList.contains('is-open') ? closeDD(it) : openDDi(it); });
      on(it, 'keydown', function (e) { if (e.key === 'Escape' && it.classList.contains('is-open')) { e.preventDefault(); closeDD(it); if (b) b.focus(); } });
      on(it, 'focusout', function (e) { if (e.relatedTarget && !it.contains(e.relatedTarget)) closeDD(it); });
    });
    if (dds.length) {
      on(document, 'click', function (e) { if (openDD && !openDD.contains(e.target)) closeDD(); });
      on(window, 'scroll', function () { if (openDD && !canHover.matches) closeDD(); }, { passive: true });
    }
    H.dropdown = { close: function () { closeDD(); } };

    /* search panel */
    var search = $('[data-hdzb-search]', hdr), sBtns = $$('[data-hdzb-search-open]', hdr), sRelease = null;
    function closeSearch() {
      if (!search || search.hidden) return;
      search.hidden = true;
      sBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (sRelease) { sRelease(); sRelease = null; }
    }
    function openSearch() {
      if (!search) return;
      search.hidden = false;
      sBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      sRelease = H.trapFocus(search, { onEscape: closeSearch, initial: 'input[type="search"]', restore: true });
    }
    sBtns.forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); search.hidden ? openSearch() : closeSearch(); }); });
    if (search) {
      $$('[data-hdzb-search-close]', search).forEach(function (b) { on(b, 'click', closeSearch); });
      on(document, 'click', function (e) { if (!search.hidden && !search.contains(e.target) && !sBtns.some(function (b) { return b.contains(e.target); })) closeSearch(); });
      var input = $('input[type="search"]', search), res = $('[data-hdzb-search-results]', search);
      if (input && res) {
        /* owner 02.10: from the 2nd letter show a short fishing loader (a bobber on the water) until the suggestions arrive,
           so nobody wonders whether anything is happening during the ~1–2 s the request takes */
        var BOBBER = '<svg viewBox="0 0 72 56" aria-hidden="true" focusable="false">' +
          '<ellipse class="hdzb-sl__rip" cx="36" cy="40" rx="18" ry="4.5"/><ellipse class="hdzb-sl__rip hdzb-sl__rip--2" cx="36" cy="40" rx="18" ry="4.5"/>' +
          '<path class="hdzb-sl__water" d="M2 40 q8.5 -4 17 0 t17 0 t17 0 t17 0"/>' +
          '<g class="hdzb-sl__bob"><path d="M36 0 V20" class="hdzb-sl__line"/><rect x="34.8" y="17" width="2.4" height="7" rx="1" fill="#111"/>' +
          '<path d="M25 33 a11 11 0 0 1 22 0 Z" fill="#FF5A00" stroke="#111" stroke-width="2" stroke-linejoin="round"/>' +
          '<path d="M25 33 a11 11 0 0 0 22 0 Z" fill="#fff" stroke="#111" stroke-width="2" stroke-linejoin="round"/></g></svg>';
        var loading = function (q) {
          var t = $('[data-hdzb-sl-q]', res);
          if (t) { t.textContent = q; return; }
          res.innerHTML = '<div class="hdzb-search__load" role="status">' + BOBBER + '<p>Casting for &ldquo;<b data-hdzb-sl-q>' + esc(q) + '</b>&rdquo;&hellip;<span>Finding the right gear</span></p></div>';
        };
        on(input, 'input', function () { var q = input.value.trim(); if (q.length >= 2) loading(q); else res.innerHTML = ''; });
        var run = debounce(function () {
          var q = input.value.trim();
          if (q.length < 2) { res.innerHTML = ''; return; }
          var url = (R.suggest || (root + '/search/suggest')) + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag';
          fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
            if (input.value.trim() !== q) return;
            var p = (j.resources && j.resources.results && j.resources.results.products) || [];
            var c = (j.resources && j.resources.results && j.resources.results.collections) || [];
            var html = p.map(function (x) {
              var img = x.featured_image && x.featured_image.url ? '<img src="' + esc(x.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_112x112$1$2')) + '" alt="" loading="lazy" width="56" height="56">' : '<span></span>';
              var price = x.price ? H.money(Math.round(parseFloat(x.price) * 100)) : '';
              return '<a class="hdzb-search__r" href="' + esc(x.url) + '">' + img + '<span><b>' + esc(x.title) + '</b><span>' + esc(price) + '</span></span></a>';
            }).join('') + c.map(function (x) {
              return '<a class="hdzb-search__r" href="' + esc(x.url) + '"><span></span><span><b>' + esc(x.title) + '</b><span>Collection</span></span></a>';
            }).join('');
            if (!html) html = '<p class="hdzb-small">Nothing for "' + esc(q) + '". Try "reel", "rod" or "line".</p>';
            else html += '<a class="hdzb-search__all" href="' + (R.search || (root + '/search')) + '?q=' + encodeURIComponent(q) + '&type=product">See all results for "' + esc(q) + '" →</a>';
            res.innerHTML = html;
          }).catch(function () { if (input.value.trim() === q) res.innerHTML = '<p class="hdzb-small">Press Search to see everything for "' + esc(q) + '".</p>'; });
        }, 220);
        on(input, 'input', run);
      }
    }
    H.search = { open: openSearch, close: closeSearch };
    on(window, 'resize', debounce(function () { if (window.innerWidth >= 990) closeDrawer(); }, 200));
  }

  /* ---------- rails (CSS scroll-snap + desktop arrows) ---------- */
  H.initRails = function (scope) {
    $$('[data-hdzb-rail]', scope).forEach(function (rail) {
      if (rail.__hdzb) return; rail.__hdzb = true;
      var track = $('.hdzb-rail__track', rail); if (!track) return;
      var prev = $('.hdzb-rail__arrow--prev', rail), next = $('.hdzb-rail__arrow--next', rail);
      function step() { var c = track.children[0]; if (!c) return 300; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0; return c.getBoundingClientRect().width + gap; }
      function upd() { if (!prev || !next) return; var max = track.scrollWidth - track.clientWidth - 2; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max; }
      if (prev) on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) on(next, 'click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(track, 'scroll', debounce(upd, 80), { passive: true }); upd(); setTimeout(upd, 500);
    });
  };

  /* ---------- quantity steppers: <div data-hdzb-qty><button data-dir="-1">…<input>…<button data-dir="1"></div> ---------- */
  H.initSteppers = function (scope) {
    $$('[data-hdzb-qty]', scope).forEach(function (q) {
      if (q.__hdzb) return; q.__hdzb = true;
      var input = $('input', q); if (!input) return;
      var min = Number(input.min || 0), max = input.max ? Number(input.max) : Infinity;
      function set(v) {
        v = Math.max(min, Math.min(max, Math.round(Number(v) || 0)));
        if (String(v) !== input.value) { input.value = v; input.dispatchEvent(new Event('change', { bubbles: true })); }
        $$('[data-dir]', q).forEach(function (b) { b.disabled = (Number(b.getAttribute('data-dir')) < 0) ? v <= min : v >= max; });
      }
      $$('[data-dir]', q).forEach(function (b) { on(b, 'click', function () { set(Number(input.value) + Number(b.getAttribute('data-dir'))); }); });
      on(input, 'change', function () { set(input.value); });
      set(input.value);
    });
  };

  /* ---------- segmented controls & tier cards (role=radio buttons) ---------- */
  H.initRadios = function (scope) {
    $$('[data-hdzb-radios]', scope).forEach(function (g) {
      if (g.__hdzb) return; g.__hdzb = true;
      var opts = $$('[role="radio"]', g);
      function pick(el) {
        opts.forEach(function (o) { var onIt = o === el; o.classList.toggle('is-on', onIt); o.setAttribute('aria-checked', onIt ? 'true' : 'false'); o.tabIndex = onIt ? 0 : -1; });
        g.dispatchEvent(new CustomEvent('hdzb:change', { bubbles: true, detail: { value: el.getAttribute('data-value'), el: el, group: g } }));
      }
      opts.forEach(function (o, i) {
        if (!o.hasAttribute('tabindex')) o.tabIndex = o.getAttribute('aria-checked') === 'true' ? 0 : -1;
        on(o, 'click', function () { if (!o.disabled) pick(o); });
        on(o, 'keydown', function (e) {
          var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (!d) return; e.preventDefault(); var n = opts[(i + d + opts.length) % opts.length]; n.focus(); pick(n);
        });
      });
    });
  };

  /* ---------- lazy video: <div class="hdzb-video hdzb-ratio" data-hdzb-video data-src data-poster data-mode="auto|click"> ---------- */
  function buildVideo(box, withControls) {
    var v = document.createElement('video');
    v.muted = !withControls; v.defaultMuted = !withControls; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.loop = box.getAttribute('data-loop') !== 'false'; v.preload = 'metadata';
    if (withControls) { v.controls = true; v.loop = false; } else { v.autoplay = true; v.setAttribute('muted', ''); v.setAttribute('autoplay', ''); }
    if (box.getAttribute('data-poster')) v.poster = box.getAttribute('data-poster');
    v.setAttribute('aria-label', box.getAttribute('data-label') || 'Video');
    v.src = box.getAttribute('data-src');
    box.appendChild(v);
    return v;
  }
  function playSafe(v) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () { v.addEventListener('canplay', function h() { v.removeEventListener('canplay', h); v.play().catch(function () { }); }); }); }
  H.initVideos = function (scope) {
    var boxes = $$('[data-hdzb-video]', scope).filter(function (b) { return !b.__hdzb; });
    if (!boxes.length) return;
    boxes.forEach(function (b) { b.__hdzb = true; });
    var clicks = boxes.filter(function (b) { return b.getAttribute('data-mode') === 'click'; });
    clicks.forEach(function (box) {
      var btn = $('.hdzb-video__play', box);
      var start = function () { if (box.__v) return; box.__v = buildVideo(box, true); box.classList.add('is-playing'); playSafe(box.__v); };
      if (btn) on(btn, 'click', start); else on(box, 'click', start);
    });
    var autos = boxes.filter(function (b) { return b.getAttribute('data-mode') !== 'click'; });
    if (!autos.length) return;
    function activate(box) { if (!box.__v) { box.__v = buildVideo(box, false); box.classList.add('is-playing'); } playSafe(box.__v); }
    if (!('IntersectionObserver' in window)) { autos.forEach(activate); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var b = e.target; if (e.isIntersecting) activate(b); else if (b.__v && !b.__v.paused) b.__v.pause(); }); }, { rootMargin: '240px 0px' });
    autos.forEach(function (b) { io.observe(b); });
  };

  /* ---------- sticky ATC bar: <div class="hdzb-sticky" data-hdzb-sticky data-target="#buybox"> shows once the target scrolls above the viewport ---------- */
  H.initSticky = function (scope) {
    $$('[data-hdzb-sticky]', scope).forEach(function (bar) {
      if (bar.__hdzb) return; bar.__hdzb = true;
      if (bar.parentNode !== document.body) document.body.appendChild(bar);
      var target = bar.getAttribute('data-target') ? $(bar.getAttribute('data-target')) : null;
      if (!target) { bar.classList.add('is-on'); document.body.classList.add('hdzb-has-sticky'); return; }
      /* scroll-driven (not IntersectionObserver): a jump from the bottom to the top can skip the target entirely and IO would never fire */
      var tick = false;
      function upd() { var r = target.getBoundingClientRect(); var show = r.bottom < 0; bar.classList.toggle('is-on', show); document.body.classList.toggle('hdzb-has-sticky', show); tick = false; }
      on(window, 'scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
      on(window, 'resize', debounce(upd, 150));
      upd(); setTimeout(upd, 600);
      var a = $('a[href^="#"]', bar);
      if (a) on(a, 'click', function (e) { var t = $(a.getAttribute('href')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    });
  };

  var CHECK_SVG = '<svg class="hdzb-i" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:16px;height:16px"><path d="M20 6 9 17l-5-5"/></svg>';
  /* ---------- declarative add-to-cart: <button data-hdzb-add data-id="VARIANT" data-qty="1" data-open="false"> ---------- */
  function initAddButtons(scope) {
    $$('[data-hdzb-add]', scope).forEach(function (b) {
      if (b.__hdzb) return; b.__hdzb = true;
      on(b, 'click', function (e) {
        e.preventDefault();
        if (b.classList.contains('is-busy')) return;
        var items;
        if (b.getAttribute('data-items')) { try { items = JSON.parse(b.getAttribute('data-items')); } catch (err) { items = null; } }
        if (!items) items = [{ id: Number(b.getAttribute('data-id')), quantity: Number(b.getAttribute('data-qty')) || 1 }];
        if (!items[0] || !items[0].id) { var f = b.getAttribute('data-fallback'); if (f) window.location.href = f; return; }
        var label = b.innerHTML; b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
        if (b.getAttribute('data-busy-text')) b.textContent = b.getAttribute('data-busy-text');
        var ok = false;
        cart.add(items, { open: b.getAttribute('data-open') !== 'false', toast: b.getAttribute('data-toast') || undefined })
          .then(function () { ok = true; }, function () { })
          .then(function () {
            b.classList.remove('is-busy'); b.removeAttribute('aria-busy');
            if (!ok || b.getAttribute('data-done') === 'false') { b.innerHTML = label; return; }
            /* feedback: "Added ✓" for a moment, then the original label */
            b.innerHTML = CHECK_SVG + '<span>' + esc(b.getAttribute('data-done-text') || 'Added') + '</span>';
            b.classList.add('is-done');
            setTimeout(function () { b.classList.remove('is-done'); b.innerHTML = label; }, 1800);
          });
      });
    });
  }

  /* ---------- reveal on scroll: [data-hdzb-reveal] / [data-hdzb-reveal="stagger"] ---------- */
  var revealIO = null;
  H.initReveal = function (scope) {
    var els = $$('[data-hdzb-reveal]', scope).filter(function (el) { return !el.__rv; });
    if (scope && scope.nodeType === 1 && scope.hasAttribute && scope.hasAttribute('data-hdzb-reveal') && !scope.__rv) els.unshift(scope);
    if (!els.length) return;
    var design = window.Shopify && window.Shopify.designMode;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      el.__rv = true;
      if (el.getAttribute('data-hdzb-reveal') === 'stagger') Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--hdzb-i', i); });
      /* already on screen (or no IO / reduced motion / editor) → shown at once, never hidden */
      if (design || reduced() || !('IntersectionObserver' in window) || el.getBoundingClientRect().top < vh * 0.92) el.classList.add('is-in');
    });
    document.documentElement.classList.add('hdzb-rv');
    if (!('IntersectionObserver' in window)) return;
    if (!revealIO) revealIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    els.forEach(function (el) { if (!el.classList.contains('is-in')) revealIO.observe(el); });
  };
  H.revealAll = function () { $$('[data-hdzb-reveal]').forEach(function (el) { el.classList.add('is-in'); if (revealIO) revealIO.unobserve(el); }); };
  on(window, 'beforeprint', function () { H.revealAll(); });

  /* ---------- product media fade-in: only images still loading get hidden (cached ones never flash) ---------- */
  H.initFade = function (scope) {
    if (reduced()) return;
    $$('.hdzb-pcard__media img, img.hdzb-img, .hdzb-ratio > img', scope).forEach(function (img) {
      if (img.__fd || img.complete || img.loading === 'eager' || img.getAttribute('fetchpriority') === 'high') return; img.__fd = true;
      img.classList.add('hdzb-fade');
      var done = function () { img.classList.add('is-loaded'); };
      img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
      if (img.complete) done();
    });
  };

  /* ---------- accordion height animation (details.hdzb-acc__i > summary.hdzb-acc__q + .hdzb-acc__a) ---------- */
  on(document, 'click', function (e) {
    var sum = e.target.closest && e.target.closest('details.hdzb-acc__i > summary');
    if (!sum || reduced() || typeof Element.prototype.animate !== 'function') return;
    var det = sum.parentNode, body = $('.hdzb-acc__a', det);
    if (!body || det.__anim) return;
    e.preventDefault();
    var opening = !det.open;
    if (opening) det.open = true;
    var h = body.scrollHeight;
    body.style.overflow = 'hidden';
    det.__anim = body.animate(opening
      ? [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }]
      : [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: opening ? 320 : 240, easing: 'cubic-bezier(.2,.8,.2,1)' });
    det.__anim.onfinish = det.__anim.oncancel = function () { det.__anim = null; body.style.overflow = ''; if (!opening) det.open = false; };
  });

  /* ---------- back to top ---------- */
  on(document, 'click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hdzb-top]'); if (!b) return;
    e.preventDefault(); window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
  });

  /* ---------- smooth anchors inside .hdzb ---------- */
  on(document, 'click', function (e) {
    var a = e.target.closest && e.target.closest('.hdzb a[href^="#"]:not([href="#"])');
    if (!a) return; var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- "Low in stock" by visitor interest (owner decision 01.10.2026) ----------
     The label appears on the products THIS visitor keeps coming back to. Stored only in this browser
     (localStorage "hdzb_interest": product handle → [minute, points, why] events; nothing personal, no network).
     Signals: product-page view +1 (once per 30 min) · 30 s visible on it +1 · 90 s +1 · hand/variant change or the buy
     box / reviews scrolled into view +1 (once per view) · added to cart +2 · removed from the cart +1 · seen again on
     another day +2. Events older than 14 days drop out. Score ≥ min (Theme settings → Product cards (HDZB), default 3)
     → flagged; at most `max` products (default 2) at once, highest score first. Never on sold-out or technical products.
     Where: product cards ([data-hdzb-card] / [data-hdzb-lowable] with data-handle → chip into [data-hdzb-low-slot]) and
     the product page's own buy box (.hdzp-buy[data-handle]). Server chips (real stock "Only N left" / manual list) win.
     Settings + page context come from <script data-hdzb-ctx> (sections/hdzb-header.liquid). */
  var CTX = {};
  try { var ctxEl = document.querySelector('script[data-hdzb-ctx]'); if (ctxEl) CTX = JSON.parse(ctxEl.textContent) || {}; } catch (e) { CTX = {}; }
  var LOWC = CTX.low || {}, TECH = CTX.tech || [], IKEY = 'hdzb_interest', KEEP_MIN = 14 * 1440;
  function nowMin() { return Math.floor(Date.now() / 60000); }
  function dayOf(min) { var d = new Date(min * 60000); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  function isTech(h, type) { return !h || TECH.indexOf(h) > -1 || /upcart|shipping protection|warranty/i.test(type || ''); }
  function iRead() { try { var j = JSON.parse(window.localStorage.getItem(IKEY) || 'null'); if (j && j.v === 1 && j.p && typeof j.p === 'object') return j; } catch (e) { } return { v: 1, p: {} }; }
  function iScore(r) { var cut = nowMin() - KEEP_MIN, s = 0; (r.e || []).forEach(function (x) { if (x[0] >= cut) s += Number(x[1]) || 0; }); return s; }
  function iLast(r) { var t = r.lv || 0; (r.e || []).forEach(function (x) { if (x[0] > t) t = x[0]; }); return t; }
  function iWrite(st) {
    var cut = nowMin() - KEEP_MIN;
    Object.keys(st.p).forEach(function (h) { var r = st.p[h]; r.e = (r.e || []).filter(function (x) { return x[0] >= cut; }).slice(-40); if (!r.e.length && !(r.lv >= cut)) delete st.p[h]; });
    var hs = Object.keys(st.p);
    if (hs.length > 40) hs.sort(function (a, b) { return iScore(st.p[a]) - iScore(st.p[b]) || iLast(st.p[a]) - iLast(st.p[b]); }).slice(0, hs.length - 40).forEach(function (h) { delete st.p[h]; });
    try { window.localStorage.setItem(IKEY, JSON.stringify(st)); } catch (e) { }
    return st;
  }
  function iFlagged() {
    if (LOWC.on === false) return [];
    var st = iRead(), min = Number(LOWC.min) || 3, max = LOWC.max == null ? 2 : Number(LOWC.max);
    if (!(max > 0)) return [];
    return Object.keys(st.p).map(function (h) { var r = st.p[h]; return { h: h, s: iScore(r), t: iLast(r), a: r.a }; })
      .filter(function (x) { return x.s >= min && x.a !== 0 && !isTech(x.h); })
      .sort(function (a, b) { return b.s - a.s || b.t - a.t; })
      .slice(0, max).map(function (x) { return x.h; });
  }
  function iBump(h, pts, why) {
    if (isTech(h)) return;
    var st = iRead(), r = st.p[h] || (st.p[h] = { e: [] });
    r.e = r.e || []; r.e.push([nowMin(), pts, why || '']);
    iWrite(st); applyLow(document);
  }
  function lowChip(extra) {
    var s = document.createElement('span');
    s.className = 'hdzb-low ' + extra; s.setAttribute('data-hdzb-low', 'interest');
    var i = document.createElement('i'); i.setAttribute('aria-hidden', 'true'); s.appendChild(i);
    s.appendChild(document.createTextNode(LOWC.label || 'Low in stock'));
    return s;
  }
  function applyLow(scope) {
    scope = scope || document;
    var fl = iFlagged(), list = LOWC.list || [];
    $$('[data-hdzb-card][data-handle], [data-hdzb-lowable][data-handle]', scope).forEach(function (card) {
      var h = card.getAttribute('data-handle');
      var mine = card.querySelector('[data-hdzb-low="interest"]');
      var server = card.querySelector('[data-hdzb-low]:not([data-hdzb-low="interest"])');
      var want = !server && fl.indexOf(h) > -1 && card.getAttribute('data-avail') !== 'false' && !card.classList.contains('hdzb-pcard--sold');
      if (want && !mine) { var slot = card.querySelector('[data-hdzb-low-slot]') || card; slot.appendChild(lowChip('hdzb-pcard__low')); }
      else if (!want && mine) mine.parentNode.removeChild(mine);
    });
    var p = CTX.product;
    if (CTX.tpl === 'product' && p && p.handle) {
      $$('.hdzp-buy[data-handle]', scope).forEach(function (box) {
        if (box.getAttribute('data-handle') !== p.handle) return;
        var mine = null; Array.prototype.forEach.call(box.children, function (c) { if (c.hasAttribute && c.hasAttribute('data-hdzb-low')) mine = c; });
        var want = p.avail !== false && !isTech(p.handle, p.type) && (list.indexOf(p.handle) > -1 || fl.indexOf(p.handle) > -1);
        if (want && !mine) { box.classList.add('hdzb-low-host'); var c = lowChip('hdzb-low--pdp'); if (list.indexOf(p.handle) > -1) c.setAttribute('data-hdzb-low', 'list'); box.insertBefore(c, box.firstChild); }
        else if (!want && mine) mine.parentNode.removeChild(mine);
      });
    }
  }
  function trackProductPage() {
    var p = CTX.product; if (CTX.tpl !== 'product' || !p || !p.handle || isTech(p.handle, p.type)) return;
    var h = p.handle, st = iRead(), r = st.p[h] || (st.p[h] = { e: [] }), n = nowMin();
    r.e = r.e || []; r.a = p.avail === false ? 0 : 1;
    if (!r.lv || n - r.lv >= 30) {
      if (r.lv && dayOf(r.lv) !== dayOf(n)) r.e.push([n, 2, 'day']);
      r.e.push([n, 1, 'view']); r.lv = n;
    }
    iWrite(st);
    /* time on the page (visible only) */
    var secs = 0, t30 = false;
    var iv = setInterval(function () {
      if (document.visibilityState && document.visibilityState !== 'visible') return;
      secs++;
      if (!t30 && secs >= 30) { t30 = true; iBump(h, 1, 't30'); }
      if (secs >= 90) { clearInterval(iv); iBump(h, 1, 't90'); }
    }, 1000);
    /* engagement: hand / variant change, or the buy box / reviews scrolled into view (once per view) */
    var engaged = false;
    function engage() { if (engaged) return; engaged = true; iBump(h, 1, 'engage'); }
    var BUY = '.hdzp-buy, form[action*="/cart/add"]';
    on(document, 'change', function (e) { if (e.target && e.target.closest && e.target.closest(BUY)) engage(); }, true);
    on(document, 'click', function (e) { var t = e.target && e.target.closest && e.target.closest('[role="radio"], .hdzb-seg__o, select, input[type="radio"]'); if (t && t.closest(BUY)) engage(); }, true);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && (window.scrollY || 0) > 300) { engage(); io.disconnect(); } }); }, { threshold: 0.35 });
      $$('.hdzp-buy, #reviews, .hdzpa-fb').forEach(function (el) { io.observe(el); });
    }
  }
  /* add / remove: diff the cart's product handles on every cart refresh (our quick add, PDP forms via UpCart, the drawer) */
  var cartHandles = (CTX.cart || []).slice();
  H.on('hdzb:cart', function (d) {
    var c = d && d.cart; if (!c || !c.items) return;
    var now = []; c.items.forEach(function (it) { if (it.handle && now.indexOf(it.handle) < 0) now.push(it.handle); });
    if (d.source !== 'clear') {
      now.forEach(function (h) { if (cartHandles.indexOf(h) < 0) iBump(h, 2, 'add'); });
      cartHandles.forEach(function (h) { if (now.indexOf(h) < 0) iBump(h, 1, 'remove'); });
    }
    cartHandles = now;
  });
  H.interest = {
    get: iRead,
    score: function (h) { var r = iRead().p[h]; return r ? iScore(r) : 0; },
    flagged: iFlagged,
    bump: function (h, pts, why) { iBump(h, Number(pts) || 1, why || 'manual'); },
    apply: applyLow,
    reset: function () { try { window.localStorage.removeItem(IKEY); } catch (e) { } applyLow(document); }
  };

  /* ---------- init ---------- */
  H.init = function (scope) { H.initRails(scope); H.initSteppers(scope); H.initRadios(scope); H.initVideos(scope); H.initSticky(scope); initAddButtons(scope); H.initFade(scope); H.initReveal(scope); applyLow(scope); };
  function boot() {
    initHeader();
    trackProductPage();
    H.init(document);
    /* cards added later without HDZB.init (tabs, load more, app widgets) still get the chip */
    if ('MutationObserver' in window && document.body) {
      var lowPend = false;
      new MutationObserver(function (ms) {
        if (lowPend) return;
        for (var i = 0; i < ms.length; i++) {
          var add = ms[i].addedNodes;
          for (var j = 0; j < add.length; j++) {
            var nd = add[j];
            if (nd.nodeType === 1 && (nd.hasAttribute('data-hdzb-card') || nd.hasAttribute('data-hdzb-lowable') || (nd.querySelector && nd.querySelector('[data-hdzb-card], [data-hdzb-lowable], .hdzp-buy')))) {
              lowPend = true; requestAnimationFrame(function () { lowPend = false; applyLow(document); }); return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    updateCounts(Number(CFG.cartCount) || 0);
    /* keep the count honest after UpCart changes the cart from inside its drawer */
    var sync = debounce(function () { cart.get().catch(function () { }); }, 350);
    function hookUpcart() {
      var hooked = false;
      ['upcartSubscribeCartUpdated', 'upcartSubscribeItemRemoved', 'upcartSubscribeAddedToCart'].forEach(function (k) {
        if (typeof window[k] === 'function') { try { window[k](sync); hooked = true; } catch (e) { } }
      });
      return hooked;
    }
    if (!hookUpcart()) { var tries = 0; var t = setInterval(function () { if (hookUpcart() || ++tries > 20) clearInterval(t); }, 500); }
    on(window, 'pageshow', function (e) { if (e.persisted) sync(); });
    on(document, 'visibilitychange', function () { if (!document.hidden) sync(); });
    /* theme editor: re-init sections that get re-rendered */
    on(document, 'shopify:section:load', function (e) { H.init(e.target); if (e.target && e.target.querySelector('[data-hdzb-header]')) initHeader(); });
  }
  window.HDZB = H;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
